<ng-container *ngIf="person$ | async as person">
    <isav-people-shared-view-page [person]="person" [isGlobalMap]="true">
        <isav-action-title [title]="person.fullName">
            <a *isavCanEditPerson="person['@id']" [isavEditLink]="person" isavBtn color="primary">
                Edit
            </a>
            <button isavBtn color="primary" isavPrintPage>Print page</button>
        </isav-action-title>
    </isav-people-shared-view-page>
    <isav-people-associated-content [iri]="person['@id']"></isav-people-associated-content>
    <isav-page-content class="pb-0 pt-0">
        <isav-domain-event-journal-list [iri]="person['@id']"></isav-domain-event-journal-list>
    </isav-page-content>
</ng-container>
